/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Practice_Drag_CancelInputs */



/**
* | output |
* | --- |
* | "Move of {title} cancelled." |
*
* @param {Practice_Drag_CancelInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const practice_drag_cancel = /** @type {((inputs: Practice_Drag_CancelInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Practice_Drag_CancelInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ (`Verplaatsen van ${i?.title} geannuleerd.`)
	if (locale === "fr") return /** @type {LocalizedString} */ (`Déplacement de ${i?.title} annulé.`)
	return /** @type {LocalizedString} */ (`Move of ${i?.title} cancelled.`)
});